import { Component, OnInit } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { I18nService } from 'src/app/services/i18n.service';

@Component({
  selector: 'app-footer',
  templateUrl: './footer.component.html',
  styleUrls: ['./footer.component.scss']
})
export class FooterComponent implements OnInit {
  currentYear = new Date().getFullYear();
  currentLang;
  constructor(
    private i18nService: I18nService,
      private translate: TranslateService,
  ) { 
    this.i18nService.getLang().subscribe((lng) => {
      if(lng == null){
        lng = 'ar';
      }
      this.currentLang = lng;
      this.translate.use(this.currentLang);
    });
  }

  ngOnInit() {
  }

}
